import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const TableReportCapacity = () => {
  return (
    <HomeUI />
  )
}

export default TableReportCapacity;
